export const GET_CATEGORIES_LIST = 'GET_CATEGORIES_LIST'
